import React from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'

import ContextProvider from '~/provider/ContextProvider'

import { GlobalStyle } from '~/utils/styles'
import Navigation from '~/components/Navigation'
import Footer from '~/components/Footer'
import '../css/fonts.css'

const Layout = ({ children, pageContext }) => {
  const {
    layout = 'default',
    initialVariant = null,
    upsell = null,
  } = pageContext
  const { key } = children
  const hideHeaderBanner = layout === 'wholesale'

  return (
    <ContextProvider>
      <GlobalStyle />
      <StaticQuery
        query={graphql`
          query SiteTitleQuery {
            site {
              siteMetadata {
                title
              }
            }
          }
        `}
        render={data => (
          <>
            <Navigation
              siteTitle={data.site.siteMetadata.title}
              hideHeaderBanner={hideHeaderBanner}
              isWholesale={layout === 'wholesale'}
            />
            {React.cloneElement(children, {
              initialVariant: initialVariant,
              upsell: upsell,
            })}
            <Footer />
          </>
        )}
      />
    </ContextProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
